import useBeautyFilterSlider from 'hooks/beautyFilter/useBeautyFilterSlider';

const BeautyFilterSlider: React.FC = () => {
  const { sliderValue, isSliderVisible, resetToDefault, handleInput, handleDragStart, handleDragEnd, isDragging } = useBeautyFilterSlider();

  const normalizedSliderValue = Math.round(sliderValue / 10);
  const sliderBackground = `linear-gradient(90deg, var(--wh-100) ${normalizedSliderValue}%, rgba(0, 0, 0, 0.5) ${normalizedSliderValue}%)`;

  return (
    <div style={{ display: isSliderVisible ? 'flex' : 'none', WebkitTapHighlightColor: 'transparent' }} className="absolute -top-14 w-full items-center justify-center gap-2 py-4">
      <div onClick={resetToDefault} className="flex h-7 w-7 items-center justify-center rounded-full bg-black/30">
        <img src="/imgweb/beauty_filter/icons/refresh.svg" alt="reset" className="h-6 w-6" />
      </div>
      <input
        type="range"
        min="0"
        max="1000"
        value={sliderValue}
        className={`${isDragging ? '[&::-webkit-slider-thumb]:scale-110' : ''} h-2 w-3/4 transform-gpu appearance-none rounded-sm outline-none [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:transform-gpu [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-[var(--wh-100)] [&::-webkit-slider-thumb]:transition-transform [&::-webkit-slider-thumb]:duration-150 [&::-webkit-slider-thumb]:ease-in-out`}
        dir="ltr"
        style={{ background: sliderBackground }}
        onTouchStart={handleDragStart}
        onMouseDown={handleDragStart}
        onTouchEnd={handleDragEnd}
        onMouseUp={handleDragEnd}
        onChange={handleInput}
        // onInput={handleInput}
      />
    </div>
  );
};

export default BeautyFilterSlider;
